(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mt-course-reviews')) {
  class MtCourseReviews extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.mt-course-track');
      if (!this.track) return;
      this.track.querySelectorAll('[data-review-copy]').forEach(card => card.remove());
      const originals = Array.from(this.track.children);
      this.count = originals.length;
      if (this.count < 2) return;
      this.active = 0;
      this.track.style.overflowAnchor = 'none';
      const copies = () => {
        const fragment = document.createDocumentFragment();
        originals.forEach(card => {
          const copy = card.cloneNode(true);
          copy.dataset.reviewCopy = '';
          copy.setAttribute('aria-hidden', 'true');
          copy.setAttribute('inert', '');
          copy.removeAttribute('id');
          copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          fragment.append(copy);
        });
        return fragment;
      };
      this.track.prepend(copies());
      this.track.append(copies());
      this.cards = Array.from(this.track.children);
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelector('.mt-course-prev')?.addEventListener('click', () => this.move(-1, true), options);
      this.querySelector('.mt-course-next')?.addEventListener('click', () => this.move(1, true), options);
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1, true);
        }
      }, options);
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.normalize(), 180);
      }, options);
      this.track.addEventListener('scrollend', () => this.normalize(), options);
      this.addEventListener('pointerenter', () => { this.hovered = true; }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; }, options);
      this.track.addEventListener('pointerdown', () => { this.dragging = true; }, options);
      window.addEventListener('pointerup', () => { this.dragging = false; }, options);
      window.addEventListener('pointercancel', () => { this.dragging = false; }, options);
      this.center(this.count, 'instant');
      this.frame = requestAnimationFrame(() => this.center(this.count, 'instant'));
      this.resizeObserver = new ResizeObserver(() => this.center(this.count + this.active, 'instant'));
      this.resizeObserver.observe(this.track);
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
      }, { threshold: 0.25 });
      this.visibilityObserver.observe(this);
      this.autoTimer = setInterval(() => {
        if (this.visible && !document.hidden && !this.hovered && !this.dragging && !this.matches(':focus-within') && !this.reducedMotion.matches) this.move(1);
      }, 5000);
    }
    nearest() {
      const bounds = this.track.getBoundingClientRect();
      const middle = bounds.left + this.track.clientWidth / 2;
      let nearest = this.count, distance = Infinity;
      this.cards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        const delta = Math.abs(rect.left + rect.width / 2 - middle);
        if (delta < distance) { nearest = index; distance = delta; }
      });
      return nearest;
    }
    center(index, behavior) {
      const card = this.cards?.[index];
      if (!card || !this.track.clientWidth) return;
      const rect = card.getBoundingClientRect();
      const bounds = this.track.getBoundingClientRect();
      this.track.scrollTo({ left: this.track.scrollLeft + rect.left - bounds.left - (this.track.clientWidth - rect.width) / 2, behavior });
    }
    normalize() {
      if (this.dragging || !this.isConnected) return;
      const index = this.nearest();
      this.active = ((index - this.count) % this.count + this.count) % this.count;
      if (index < this.count || index >= this.count * 2) this.center(this.count + this.active, 'instant');
    }
    move(direction, announce = false) {
      clearTimeout(this.settleTimer);
      this.normalize();
      const index = this.nearest() + direction;
      this.center(index, this.reducedMotion.matches ? 'instant' : 'smooth');
      if (announce) {
        const status = this.querySelector('.mt-course-status');
        if (status) status.textContent = 'Opinión ' + (((index - this.count) % this.count + this.count) % this.count + 1) + ' de ' + this.count;
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.settleTimer);
      clearInterval(this.autoTimer);
      cancelAnimationFrame(this.frame);
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
    }
  }
  customElements.define('mt-course-reviews', MtCourseReviews);
}

  } catch(e) { console.error(e); }
})();
})();
